import { Context } from "./context";
import DateTime from "date-and-time";
export function countFlights(booking, type = "all") {
    const travelers = booking["buchung/reiseteilnehmer"] ?? [];
    let counts = 0;
    travelers.forEach((trav) => {
        const flights = trav["reiseteilnehmer/flugereignisse"] || [];
        flights.forEach((flight) => {
            if (type === "charters") {
                counts += isCharterFlight(flight) ? 1 : 0;
            }
            else if (type === "full-charters") {
                counts += isFullCharterFlight(flight) ? 1 : 0;
            }
            else {
                counts += flights.length > 0 ? 1 : 0;
            }
        });
    });
    return counts;
}
export function hasFlights(booking, type = "all") {
    return countFlights(booking, type) > 0;
}
export function hasFlightType(travFlights, type) {
    const distances = [
        "kurzstrecke",
        "mittelstrecke",
        "langstrecke",
    ];
    const types = [
        "hinflug",
        "rueckflug",
        "zubringer",
        "abbringer",
        "transfer",
    ];
    for (const travFlightList of travFlights) {
        const flights = travFlightList.flights;
        for (const flight of flights) {
            if (type === "full-charter" && isFullCharterFlight(flight)) {
                return true;
            }
            else if (type === "charter" && isCharterFlight(flight)) {
                return true;
            }
            else if (type === "line" && !isCharterFlight(flight)) {
                return true;
            }
            else if (type === "stop-over" && flight["flugereignis/stop-over?"]) {
                return true;
            }
            for (const d of distances) {
                if (type === d && flight["flugereignis/distanz"] === d) {
                    return true;
                }
            }
            for (const t of types) {
                if (type === t && flight["flugereignis/art"] === t) {
                    return true;
                }
            }
        }
    }
    return false;
}
export function hasPreviousBookings() {
    return Object.keys(Context.prevBookedSeats).length > 0;
}
export function isInBookingTime(flight) {
    const range = flight["flugereignis/reservierungszeitraum"] || undefined;
    const today = new Date();
    let inStartTime = true;
    let inEndTime = true;
    if (range && range[0]) {
        const startAsString = range[0];
        const start = DateTime.parse(startAsString, "DD.MM.YYYY");
        inStartTime = today > start;
    }
    if (range && range[1]) {
        const endAsString = range[1];
        const end = DateTime.parse(endAsString, "DD.MM.YYYY");
        inEndTime = today < end;
    }
    return inStartTime && inEndTime;
}
export function isCharterFlight(flight) {
    return flight?.["flugereignis/flug-typ"] === "charter";
}
export function isFullCharterFlight(flight) {
    return isCharterFlight(flight) && flight?.["flugereignis/id"] > 0;
}
export function hasDistanceTag(flight) {
    return !!flight["flugereignis/distanz"];
}
export function getTravsWithFlight(travs) {
    return travs.filter((trav) => {
        return trav["reiseteilnehmer/flugereignisse"]?.length > 0;
    });
}
export function getAllFlights(travs) {
    return travs
        .map((trav) => {
        return trav["reiseteilnehmer/flugereignisse"] ?? [];
    })
        .flat();
}
export function getReservations(flights, flightNr, cia) {
    const seats = [];
    for (const flight of flights) {
        if (flight["flugereignis/flugnummer"] === flightNr &&
            flight["flugereignis/airline-code"] === cia &&
            !!flight["flugereignis/sitzplatz-reservierung"]) {
            seats.push(flight["flugereignis/sitzplatz-reservierung"]);
        }
    }
    return seats;
}
